<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <NextdayTreasureViewOne @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <NextdayTreasureViewTwo @get-deposit-claim="() => emits('getDepositClaim')" @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>

    <!-- theme Three -->
    <div v-if="themeStore.themeIndex === 3">
        <NextdayTreasureViewThree @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>

    <!-- theme Four -->
    <div v-if="themeStore.themeIndex === 4">
        <NextdayTreasureViewFour @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme';
import NextdayTreasureViewOne from '@/themes/themeOne/nextdayTreasure/nextdayTreasureView.vue';
import NextdayTreasureViewTwo from '@/themes/themeTwo/nextdayTreasure/nextdayTreasureView.vue';
import NextdayTreasureViewThree from '@/themes/themeThree/nextdayTreasure/nextdayTreasureView.vue';
import NextdayTreasureViewFour from '@/themes/themeFour/nextdayTreasure/nextdayTreasureView.vue';
const themeStore = useThemeStore()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
</script>
